<template>
    <div class="signupPage" >
        <header class="mainHeader">
            <div class="mainHeader__inner">
                <img src="https://www.tcl.eu/bundles/tclapp/img/logo/tcl.svg" width="175" height="49" alt="TCL The Creative Life">
            </div>
        </header>

        <section class="mainCenter">
            <el-row>
                <el-col :span="12" >
                    <div class="things-to-try">
                        <h2> TCL Alexa </h2>
                        <p> Dev-test pipeline automation, 100,000+ free apps, public and private registries </p>
                    </div>
                    <div>
                        <img src="../assets/dockercon-2018-banner.svg" alt="Docker Logo" data-reactid=".tzfuwcwrnk.0.0.1.0.1.0.0">
                    </div>
                </el-col>
                <el-col :span="8" >
                    <h3> New to TCL Alexa?</h3>
                    <p> Enter your TCL email to get started. </p>
                    <el-form>
                        <el-form-item>
                            <el-input placeholder="Enter your TCL email address"> </el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-select v-model="select" placeholder="Choose your department">
                                <el-option label="基础软件所" value="1"></el-option>
                                <el-option label="电视应用所" value="2"></el-option>
                                <el-option label="西安所" value="3"></el-option>
                                <el-option label="SQA" value="4"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <div style="text-align: right;">
                                <el-button type="primary" @click="signUp"> Sign Up </el-button>
                            </div>
                        </el-form-item>
                    </el-form>
                </el-col>
                <el-col :offset="4"></el-col>
            </el-row>
        </section>
    </div>
</template>

<<script>

import { Message } from 'element-ui';

export default {
    data() {
        return {
            select: ""
        }
    },
    methods: {
        signUp() {
            Message.success({message: "Sign up success! Please check your email to get the password"})
            this.$router.push("/console/login")
        }
    }
}
</script>

<style scoped>

.el-select {
    width: 100%;
    
}

</style>


// WEBPACK FOOTER //
// src/pages/UserSignup.vue